// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import SideMenu from '../component/SideMenu';
import type { IdNameType } from '../../../types/OfficesType';

type Props = {
  tenants: IdNameType[],
}

type State = {
  itemSelected: string,
}

class BuildingDescription extends React.Component<Props, State> {
  state: State = {
    itemSelected: 'buildingDescription',
  };

  keys = [
    'buildingDescription',
    'tenants',
    'technicalDescription',
    'sustainableDevelopment',
  ];

  onItemSelected = (itemSelected: string) => {
    this.setState({ itemSelected });
  };

  render() {
    return (
      <div className="building-description">
        <div className="title">
          <Translate value="OFFICE.BUILDINGDESCRIPTION" />
        </div>
        <SideMenu
          items={this.keys}
          itemSelected={this.state.itemSelected}
          onItemSelected={this.onItemSelected}
        >
          <div className="data">
            {
              this.state.itemSelected === 'tenants'
                ? (
                  <div className="tenants">
                    {
                      this.props.tenants !== null
                        ? (
                          <ul>
                            {this.props.tenants.map(tenant =>
                              <li key={tenant.id}>{tenant.name}</li>)
                            }
                          </ul>
                        ) : (
                          <div className="empty-state">
                            <Translate value="OFFICE.NO_TENANT" />
                          </div>
                        )
                    }
                  </div>
                ) : (
                  <div>
                    {
                      this.props[this.state.itemSelected] !== null
                        ? (
                          <div
                            dangerouslySetInnerHTML={
                              { __html: this.props[this.state.itemSelected] }
                            }
                          />
                        ) : (
                          <div className="empty-state">No {this.state.itemSelected}</div>
                        )
                    }

                  </div>
                )
            }
          </div>
        </SideMenu>
      </div>
    );
  }
}

export default withRouter(BuildingDescription);
